
const MyWork = () => {
  return (
    <section className="resume-section" id="Projects">
      <div>
        <h1>Projects Page</h1>
        <h3>Work in Progress...</h3>
      </div>
    </section>
  )
}

export default MyWork